/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { AccordionContent } from "@/src/types/AccordionContent";

const accordionContentDismissal: AccordionContent[] = [
  {
    id: 0,
    heading: "Ich bin gekündigt worden - Was jetzt?",
    text:
      "Zunächst einmal heißt es Ruhe bewahren und feststellen, ob die Kündigung überhaupt rechtswirksam war. Viele " +
      "Kündigungen können z.B. unwirksam sein, weil Fristen nicht eingehalten wurden oder weil das Kündigungsschutzgesetz nicht " +
      "beachtet wurde. Wenn Sie aber keine Kündigungsschutzklage erheben, gilt die Kündigung nach drei Wochen in jedem " +
      "Fall als wirksam, auch wenn sie eigentlich nicht gerechtfertigt war. Daher sollten Sie Ihre Kündigung professionell " +
      "von erfahrenen Anwälten prüfen lassen.",
    linkText: "Jetzt zur kostenlosen Prüfung",
    link: "/arbeit/kuendigung/kuendigung-pruefen",
  },
  {
    id: 1,
    heading: "Wie ist der Ablauf einer Kündungungschutzklage?",
    text:
      "Zunächst prüfen wir Ihre Kündigung kostenlos. Wenn die Prüfung ergibt, dass gegen die " +
      "Kündigung Klage erhoben werden kann, wird die Klage umgehend eingereicht, um die Drei-Wochen-Frist einzuhalten. " +
      "Gleichzeitig nehmen wir mit Ihrem Arbeitgeber Kontakt auf und versuchen, sich bereits vor einem " +
      "Gerichtstermin zu einigen. Oftmals kann hier eine Einigung gefunden werden (z.B. in Form einer Abfindung). Ist " +
      "dies nicht der Fall, folgen zwei Gerichtstermine - der Gütetermin und der Kammertermin - in dem dann in der " +
      "Regel eine Entscheidung gefällt wird.",
    linkText: "Mehr zum genauen Ablauf",
    link: "/arbeit/kuendigung/ablauf",
  },
  {
    id: 2,
    heading: "Was kostet eine Kündigungsschutzklage?",
    text:
      "Bei uns zahlen Sie nur, wenn wir für Sie erfolgreich sind. Sie haben also auch ohne " +
      "Rechtsschutzversicherung kein Kostenrisiko bei einer Klage. Legalbird zahlt als Prozessfinanzierer für Sie die Anwaltskosten und Sie " +
      "geben nur bei Erfolg einen Teil Ihrer erzielten Abfindung als Erfolgsprovision ab. Ein Erfolg ist zum Beispiel eine Abfindung, eine " +
      "Rückkehr auf Ihren Arbeitsplatz oder wenn Ihre fristlose Kündigung in eine ordentliche Kündigung umgewandelt " +
      "wird, damit Sie bei der Agentur für Arbeit nicht in die Sperrfrist kommen. Wenn wir nicht erfolgreich " +
      'waren, zahlen Sie nichts! Ohne diese Kostenübernahme von Legalbird, kämen beim "herkömmlichen" Anwalt ohne Prozesskostenfinanzierung schnell ' +
      "mehrere Tausend Euro für eine Kündigungsschutzklage zusammen.",
    linkText: "Mehr zu den Kosten",
    link: "/arbeit/kuendigung/kosten",
  },
  {
    id: 3,
    heading: "Welche Fristen müssen eingehalten werden?",
    text:
      "Eine Kündigungsschutzklage kann nur drei Wochen nach Erhalt der Kündigung erhoben werden. Nutzen Sie die Chance " +
      "auf eine Abfindung oder die Rückkehr auf Ihren Arbeitsplatz und starten Sie direkt!",
    linkText: "Jetzt zur kostenlosen Prüfung",
    link: "/arbeit/kuendigung/kuendigung-pruefen",
  },
  {
    id: 4,
    heading: "Wie hoch wird meine Abfindung sein?",
    text:
      "Die Höhe von Abfindungen variiert sehr stark und ist unter anderem von der Dauer der Beschäftigung " +
      "und von Ihrem Gehalt abhängig. Je länger Sie beschäftigt sind und je mehr Sie verdienen, desto höher wird Ihre " +
      "Abfindung sein. Am Ende ist die Höhe Ihrer Abfindung fast immer das Ergebnis einer Verhandlung. Es spielt also " +
      "eine wesentliche Rolle, wie gut Ihre Verhandlungsposition gegenüber Ihrem Arbeitgeber ist. Um diese " +
      "Verhandlungsposition bestmöglich auszuspielen, unterstützen wir Sie gerne - und " +
      "das ohne Kostenrisiko! Einen ersten Eindruck über Ihre Abfindungshöhe können Sie bekommen, wenn Sie unseren " +
      "Abfindungsrechner verwenden.",
    linkText: "Jetzt Abfindung berechnen",
    link: "/arbeit/kuendigung/abfindung-berechnen",
  },
];

export default accordionContentDismissal;
